import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { Loader2 } from "lucide-react";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

export function ProtectedRoute({ children, requireAdmin = false }: ProtectedRouteProps) {
  const { user, isAdmin, mfaEnabled, aal, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  // Check if user signed in via OAuth (e.g. Azure) — Microsoft handles MFA
  const isOAuthUser = user.app_metadata?.provider === "azure";

  // Strict MFA enforcement only for email/password users
  // OAuth users already completed MFA via their identity provider
  if (requireAdmin && isAdmin && !isOAuthUser && (!mfaEnabled || aal !== "aal2")) {
    return <Navigate to="/auth" replace />;
  }

  return <>{children}</>;
}
